<template>
  <div>
    <template v-for="(item, index) in validButtons">
      
      <!-- دکمه دسکتاپ -->
      <v-btn         
        v-if="!$vuetify.breakpoint.smAndDown" 
        :key="'desk-' + index"
        :class="classBtn + item.class"
        :title="item.label"
        fab
        x-small
        @click="item.action(data, item.name)"
      >
        <i :class="iconClass + item.icon"></i>
      </v-btn>

      <!-- دکمه موبایل -->
      <v-btn
        v-else
        :key="'mob-' + index"
        v-status="item.status"
        :class="classBtn + (item.class || '')"
        x-small
        rounded
        @click="item.action(data, item.name)"
      >
        <i :class="iconClass + item.icon"></i>
        <span class="mr-2 ml-2">{{ item.label }}</span>
      </v-btn>

    </template>
  </div>
</template>

<script>
export default {
  name: "button_solo",
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    action: {
      type: Function,
    },
    meta: {
      type: Object,
      default: () => ({ buttons: [] }),
    },
    limit: {
      type: Number,
      default: 0, 
    },
  },
  data() {
    return {
      classBtn: "btn btn-sm text-center ",
      iconClass: "px-1 text-center fa fa-",
      direction: "right",
      color: {
        edit: "warning",
        delete: "error",
        show: "info",
        refresh: "indigo",
      },
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-x-reverse-transition",
    };
  },
  computed: {
    validButtons() {
      if (!this.meta || !this.meta.buttons) return [];
      
      // کامنت‌ها برداشته شد: فقط دکمه‌هایی نمایش داده می‌شوند که شرط آن‌ها true باشد
      return this.meta.buttons.filter((item) => {
        if (item.condition) {
          return this.validation(item);
        }
        return true; // اگر دکمه‌ای کلاً condition نداشت، همیشه نشان داده شود
      });
    },
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
    top(val) {
      this.bottom = !val;
    },
    right(val) {
      this.left = !val;
    },
    bottom(val) {
      this.top = !val;
    },
    left(val) {
      this.right = !val;
    },
  },
  methods: {
    validation(item) {
      if (!item.condition ||item.condition===true) {
        return true;
      }

      if (!this.data || Object.keys(this.data).length === 0) {
        return false;
      }

      // شرط‌ها برای سازگاری با جاهای دیگر
      if (this.data.payment) {
        return item.condition(this.data.payment);
      } else if (this.data.deleted_at) {
        return item.condition(this.data.deleted_at);
      } else if (this.data.provider === "divar_shop") {
        return item.condition("فروشگاه");
      } else {
        // تغییر اصلی اینجاست: کل آبجکت ردیف پاس داده می‌شود
        return item.condition(this.data);
      }
    },
  },
};
</script>

<style>
#create .v-speed-dial {
  position: absolute;
}

#create .v-btn--floating {
  position: relative;
}
.stbtn {
  display: flex;
  gap: 2px;
}
</style>
